var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVampire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 20,
    viewBox: "0 0 36 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-vampire-1383068",
    d: "M250.658,404.056a.559.559,0,0,1-.911.086,3.863,3.863,0,0,0-3.689-1.324,3.974,3.974,0,0,0-3,3.624.6.6,0,0,1-.27.445.555.555,0,0,1-.517.034,6.466,6.466,0,0,0-2.542-.531,5.793,5.793,0,0,0-2.2.428,6.793,6.793,0,0,0-3.116,2.608.558.558,0,0,1-.967,0,6.8,6.8,0,0,0-3.116-2.608,5.793,5.793,0,0,0-2.2-.428,6.463,6.463,0,0,0-2.542.531.555.555,0,0,1-.517-.034.565.565,0,0,1-.27-.445,3.973,3.973,0,0,0-3-3.624,3.858,3.858,0,0,0-3.689,1.324.588.588,0,0,1-.478.194.563.563,0,0,1-.433-.285c-.112-.188-2.683-4.771-.169-9.421a9.453,9.453,0,0,1,8.779-4.913.575.575,0,0,1,.529.639,7.648,7.648,0,0,0,1.378,5.284,7.427,7.427,0,0,0,3.537,2.625l-.321-5.039a.579.579,0,0,1,.332-.559.555.555,0,0,1,.63.12l2.036,2.066,2.036-2.066a.555.555,0,0,1,.63-.12.58.58,0,0,1,.332.559l-.321,5.039a7.439,7.439,0,0,0,3.537-2.625,7.648,7.648,0,0,0,1.378-5.284.572.572,0,0,1,.129-.434.585.585,0,0,1,.4-.205,9.436,9.436,0,0,1,8.779,4.913c2.519,4.662-.056,9.233-.169,9.427Z",
    transform: "translate(-215.928 -389.705)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVampire);
export default __webpack_public_path__ + "static/media/icoVampire.ea177549cbeae8f6d735f0f24f8f83cc.svg";
export { ForwardRef as ReactComponent };